<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-if="!loading">
                    <data-table :headings="vehicleHeadings" :data="vehicles" :hasActions="true"
                                :hasNoPaging="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @actionClicked="onVehicleActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        <template #actionButton>
                            <div class="w-100">
                                <button class="btn btn-primary" @click="onAddVehicleClick" id="btnLogisticsVehicleAddVehicle">Add Vehicle</button>
                            </div>
                        </template>
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                               :componentId="'customerFilterRadioButtons'"
                                                               @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <mark-as-active-inactive-modal
                :heading="vehicleMarkAsActiveInactiveModal.heading"
                :modalId="vehicleMarkAsActiveInactiveModal.modalId"
                :isSaving="vehicleMarkAsActiveInactiveModal.isSaving"
                :showModal="vehicleMarkAsActiveInactiveModal.showModal"
                :isActive="vehicleMarkAsActiveInactiveModal.isActive"
                @closeClicked="vehicleMarkAsActiveInactiveModal.showModal = false"
                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>
    
    <modal-form
            :heading="vehicleAddEditFormModal.heading"
            :modalId="vehicleAddEditFormModal.modalId"
            :isSaving="vehicleAddEditFormModal.isSaving"
            :showModal="vehicleAddEditFormModal.showModal"
            @closeClicked="onAddOrEditVehicleModalCloseClick"
            @saveButtonClicked="onAddOrEditVehicleSaveClick">
        <template #form>
            <div class="form-group">
                <label for="makeInput">
                    Make
                </label>
                <div class="text-danger" v-if="vehicleAddEditFormModal.vehicle.vehicleMake.hasError">
                    {{vehicleAddEditFormModal.vehicle.vehicleMake.errorMessage}}
                </div>
                <input type="text" class="form-control" id="makeInput" v-model="vehicleAddEditFormModal.vehicle.vehicleMake.value">
            </div>
            <div class="form-group">
                <label for="modelInput">
                    Model
                </label>
                <div class="text-danger" v-if="vehicleAddEditFormModal.vehicle.vehicleModel.hasError">
                    {{vehicleAddEditFormModal.vehicle.vehicleModel.errorMessage}}
                </div>
                <input type="text" class="form-control" id="modelInput" v-model="vehicleAddEditFormModal.vehicle.vehicleModel.value">
            </div>
            <div class="form-group">
                <label for="yearInput">
                    Year
                </label>
                <div class="text-danger" v-if="vehicleAddEditFormModal.vehicle.vehicleYear.hasError">
                    {{vehicleAddEditFormModal.vehicle.vehicleYear.errorMessage}}
                </div>
                <input type="text" class="form-control" id="yearInput" v-model="vehicleAddEditFormModal.vehicle.vehicleYear.value">
            </div>
            <div class="form-group">
                <label for="vehicleRegistrationInput">
                    Vehicle Registration
                </label>
                <div class="text-danger" v-if="vehicleAddEditFormModal.vehicle.vehicleRegistration.hasError">
                    {{vehicleAddEditFormModal.vehicle.vehicleRegistration.errorMessage}}
                </div>
                <input type="text" class="form-control" id="vehicleRegistrationInput" v-model="vehicleAddEditFormModal.vehicle.vehicleRegistration.value">
            </div>
            <div class="form-group">
                <label for="trailerRegistrationInput">
                    Trailer Registration
                </label>
                <div class="text-danger" v-if="vehicleAddEditFormModal.vehicle.trailerRegistration.hasError">
                    {{vehicleAddEditFormModal.vehicle.trailerRegistration.errorMessage}}
                </div>
                <input type="text" class="form-control" id="trailerRegistrationInput" v-model="vehicleAddEditFormModal.vehicle.trailerRegistration.value">
            </div>
            <div class="form-group">
                <label for="fleetNumberInput">
                    Fleet Number
                </label>
                <div class="text-danger" v-if="vehicleAddEditFormModal.vehicle.fleetNumber.hasError">
                    {{vehicleAddEditFormModal.vehicle.fleetNumber.errorMessage}}
                </div>
                <input type="text" class="form-control" id="fleetNumberInput" v-model="vehicleAddEditFormModal.vehicle.fleetNumber.value">
            </div>
            <div class="form-group">
                <label for="capacityInput">
                    Capacity (Litres)
                </label>
                <div class="text-danger" v-if="vehicleAddEditFormModal.vehicle.capacity.hasError">
                    {{vehicleAddEditFormModal.vehicle.capacity.errorMessage}}
                </div>
                <input type="text" class="form-control" id="capacityInput" v-model="vehicleAddEditFormModal.vehicle.capacity.value">
            </div>
            <div class="text-danger">
                {{vehicleAddEditFormModal.vehicle.vehicleCompartmentError}}
            </div>
            <vehicle-compartments-table
                :vehicleId="vehicleAddEditFormModal.vehicle.vehicleId"
                :clearModels="!vehicleAddEditFormModal.showModal"
                @capacityChanged="onCapacityChangedForComponents"
                @compartmentRemoved="onCompartmentRemoved"></vehicle-compartments-table>
            <div class="form-group">
                <label for="driversSelect">
                    Default Driver
                </label>
                <div class="text-danger" v-if="vehicleAddEditFormModal.vehicle.driverId.hasError">
                    {{vehicleAddEditFormModal.vehicle.driverId.errorMessage}}
                </div>
                <bootstrap-select  :selectOptions="drivers" :selectedOption="vehicleAddEditFormModal.vehicle.driverId.value" :elementId="'driversSelect'"
                                   :returnSelectedOptionText="true"
                                   @changeSelect="onDriverSelect"></bootstrap-select>
            </div>
        </template>
    </modal-form>
</div>
